"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.service = void 0;
var qs = require('qs');
exports.service = function (axios) {
    return {
        //서비스별 도메인 조회
        getServicesServiceNoDomains: function (request) {
            var query = qs.stringify(request.params);
            return axios.get("/services/" + request.pathParams.serviceNo + "/domains?" + query);
        },
        //서비스별 만료 도메인 조회
        getServicesServiceNoExpiredDomains: function (request) {
            var query = qs.stringify(request.params);
            return axios.get("/services/" + request.pathParams.serviceNo + "/expired-domains?" + query);
        },
        //대표 도메인/보안서버 연결상태 조회
        getServicesServiceNoMainDomains: function (request) {
            return axios.get("/services/" + request.pathParams.serviceNo + "/main-domains");
        },
        //구매한 도메인 리스트 조회
        getServicesServiceNoDomainsDomainNoOrder: function (request) {
            return axios.get("/services/" + request.pathParams.serviceNo + "/domains/" + request.pathParams.domainNo + "/orders");
        },
        //구매 도메인 상세 조회
        getServicesServiceNoDomainsDomainNoOrdersOrderNo: function (request) {
            var query = qs.stringify(request.params);
            return axios.get("/services/" + request.pathParams.serviceNo + "/domains/" + request.pathParams.domainNo + "/orders/" + request.pathParams.orderNo + "?" + query);
        }
    };
};
